import { inject, Pipe, PipeTransform } from '@angular/core'
import dayJS from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/fr'
import 'dayjs/locale/pt'
import 'dayjs/locale/zh-cn'
import { I18nService } from '@wm-front/core'

dayJS.extend(relativeTime)

@Pipe({
  name: 'timeFromNow',
  standalone: true,
})
export class TimeFromNowPipe implements PipeTransform {
  public i18nService = inject(I18nService)

  /**
   * Pass `now` (a timestamp from a ticker) to make the label refresh as time
   * passes. Only when `now` is given, dates after it are clamped to it, so a
   * date that arrived between two ticks reads "a few seconds ago".
   */
  public transform(date: Date, now?: number): string {
    if (date) {
      if (this.i18nService.language !== 'en-GB') {
        if (this.i18nService.language === 'zh-Hant-HK') {
          dayJS.locale('zh-cn')
        } else {
          dayJS.locale(this.i18nService.languageWithoutLocale)
        }
      }
      if (now !== undefined) {
        const reference = Math.max(now, dayJS(date).valueOf())
        return dayJS(date).from(reference)
      }
      return dayJS(date).fromNow()
    }
    return '---'
  }
}
